import classNames from 'classnames';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import PosterRow from 'src/components/posterrow/PosterRow';
import { gql } from 'graphql-request';
import { buildFilminfoQueryKey, filminfoRequest, useFilminfo } from 'src/lib/client/useFilminfo';
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import { QueryClient } from "@tanstack/react-query";
import Prefetch from "src/lib/server/reactQueryPrefetch";
import styles from './PopularMoviesList.module.css';

//#region [Props]
type PopularMoviesListProps = {
    hideHeader?: boolean;
    className?: string;
};
//#endregion

// can be called by SSR to preload data for faster rendering
export const prefetch: Prefetch = async (queryClient) => queryClient.prefetchQuery({
    queryKey: buildFilminfoQueryKey(POP_MOVIES_QUERY),
    queryFn: filminfoRequest
});


//#region [Component]
export default function PopularMoviesList({ className, hideHeader = false }: PopularMoviesListProps) {
    const { fiLoading, fiData } = useFilminfo(POP_MOVIES_QUERY, undefined, { staleTime: 55 * 60 * 1000 }); // custom stale time since this is not critical data

    return <aside className={classNames(styles.SPopularMoviesList, className)}>
        {!hideHeader && <h2 className={styles.SPopMoviesHeader}>Populære filmer</h2>}
        {fiLoading && <LoadingIndicator position='InlineCenter' />}
        {!fiLoading && <PosterRow posterList={fiData?.movieQuery?.getPopularMovies as (undefined | null | Movie[])} />}
    </aside>;
}
//#endregion

//#region [Other]
export const POP_MOVIES_QUERY = gql`
	query {
		movieQuery {
			getPopularMovies {
				__typename
				mainVersionId
				premiere
				title
				isKinoklubb
				genres
				lengthInMinutes
				rating
				sanityIdArt
				sanityImagePosterUrl
				sanityImageWideUrl
			  }
		}
	}
`;
//#endregion
